import React from 'react'
import PropTypes from 'prop-types'
import injectTranslate from 'i18n/hoc/injectTranslate'
import AnimatedLabelField from 'components/AnimatedLabelField/AnimatedLabelField'
import AnimatedPasswordField from 'components/AnimatedPasswordField/AnimatedPasswordField'
import { Text } from '@quotatisgroup/uikit-public.ui.text'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { Form, StyledButton } from './SignInFormStyle'

Form.displayName = 'Form'

const SignInFormView = ({ error, handleSubmit, translate, isLoading }) => (
  <Form onSubmit={handleSubmit}>
    <AnimatedLabelField
      name="email"
      type="email"
      icon="mail-login"
      label={translate('user.email')}
    />
    <AnimatedPasswordField
      name="password"
      label={translate('user.password')}
      margin="top-sm"
    />
    {error && (
      <Text caption color="danger" isBold>
        {translate(error)}
      </Text>
    )}
    <Text caption margin="bottom-sm">
      <UniverseLink
        id="forgot-password-link"
        color="grey"
        isBold
        href="/forgot-password"
      >
        {translate('user.forgot_password.heading')}
      </UniverseLink>
    </Text>
    <StyledButton
      id="sign-in"
      isLoading={isLoading}
      variant="primary"
      type="submit"
    >
      {translate('user.sign_in')}
    </StyledButton>
  </Form>
)

SignInFormView.propTypes = {
  isLoading: PropTypes.bool,
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  translate: PropTypes.func,
}

export default injectTranslate(SignInFormView)
